import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { documentService } from '@/services/DocumentService'
import { documentKeys } from '@/hooks/queryKeys'
import type { DocumentListDto } from '@lib/dto/document.dto'
import type { ListDocumentsQuery } from '@lib/input/document.input'

/**
 * Load documents for a scope — a site, a client, or the reusable library.
 *
 * `enabled` lets a caller hold off until it knows its scope: a site's documents
 * query with an empty `siteId` would otherwise fetch every document in the
 * system on first render.
 */
export function useDocuments(
  query: Partial<ListDocumentsQuery>,
  options: { enabled?: boolean } = {},
): UseQueryResult<DocumentListDto> {
  return useQuery({
    // The whole query, so a filter cannot be left out of the key and two
    // different lists end up sharing one cache entry.
    queryKey: documentKeys.list({ ...query }),
    queryFn: () => documentService.list(query),
    enabled: options.enabled ?? true,
    staleTime: 15_000,
  })
}
